import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { editcontactComponent } from './editcontact.component';

@Component({
  selector: 'app-detaljside',
  templateUrl: 'detaljside.page.html',
  styleUrls: ['detaljside.page.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, editcontactComponent]
})
export class DetaljsidePage {
  @Input() canChangeAddress: boolean;

  constructor(private modalCtrl: ModalController) {}

  cancel() {
    this.modalCtrl.dismiss();
  }
}
